import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { OFFER_ANCHOR } from '../data/constants';
export function Hero() {
  return <section className="border-b-4 border-tech bg-white" data-id="element-76" data-mp="9lv0spiridvb">
      <div className="h-1.5 bg-navy" aria-hidden="true" data-id="element-77" data-mp="4lqictyan92g" />
      <div className="h-1 bg-teal" aria-hidden="true" data-id="element-78" data-mp="4n1oh0f7oswq" />
      <div className="mx-auto max-w-5xl px-4 pb-5 pt-3 sm:px-6 sm:pb-7 sm:pt-5" data-id="element-79" data-mp="1297aw07qkt7q">
        <h1 className="mx-auto max-w-4xl text-center text-2xl leading-display text-navy sm:text-5xl" data-id="element-80" data-mp="1274l9hahx23j">
          THE COMPLETE PROFESSIONAL NURSING{' '}
          <span className="text-tech" data-id="element-81" data-mp="s9zybf8tt2lo">CLINICAL SKILLS &amp; PROCEDURES VISUAL SYSTEM</span>
        </h1>
        <p className="mx-auto mt-2 max-w-3xl rounded-lg bg-navy px-3 py-1.5 text-center font-display text-sm font-bold uppercase leading-tight text-white sm:text-lg" data-id="element-82" data-mp="nbeyhgxhkkxr">
          STOP SEARCHING THROUGH SCATTERED NURSING MANUALS.{' '}
          <span className="text-tech-light" data-id="element-83" data-mp="384s6grzq2r4n">
            START SEEING THE CLINICAL SKILLS YOU USE EVERY DAY.
          </span>
        </p>

        <p className="mx-auto mt-2 max-w-3xl text-center text-sm leading-snug text-steel sm:text-base" data-id="element-84" data-mp="3o858328mtl0c">
          Access clinical assessments, injection procedures, IV therapy, wound care, medication
          safety, bedside procedures, and emergency nursing references—
          <strong className="font-semibold text-navy" data-id="element-85" data-mp="30i17z4unk3e3">
            all in one complete professional visual system.
          </strong>
        </p>

        <MockupImage className="mt-2" priority data-id="element-86" data-mp="359j9pv4i2804" />

        <div className="mt-2 flex flex-col items-center" data-id="element-87" data-mp="2qjv80ssep7bv">
          <CTAButton href={OFFER_ANCHOR} data-id="element-88" data-mp="2qlep2llvzmep">
            🚀 YES! I WANT MY NURSING CLINICAL SKILLS VISUAL ATLAS NOW
          </CTAButton>
          <TrustLine items={['🛡️ 7-Day Money-Back Guarantee — Zero Risk']} data-id="element-89" data-mp="2vglkl6505ksj" />
        </div>
      </div>
    </section>;
}